import React from "react";
import {FmlxButton, FmlxCheckBox, FmlxIcon, FmlxLabel} from "fmlx-common-ui";
import QuestionPosition from "./QuestionPosition";
import {Rating} from "../../../SimpleStarRating";
import {FMLX_BUTTON, FMLX_CHECK_BOX, FMLX_COMPONENT} from "../../../const/FmlxComponentEnum";
import {fillColorArray, iconArray, QUESTION_TYPE} from "../../../const/dataEnum";

// const tooltipArray = {
//   5: ["Terrible", "Bad", "Average", "Great", "Awesome"],
//   10: ["Terrible", "Terrible+", "Bad", "Bad+", "Average", "Average+", "Great", "Great+", "Awesome", "Awesome+"],
// };
// const tooltipArray = {
//   5: ["1", "2", "3", "4", "5"],
//   10: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
// };

const Question = (
  {
    question,
    index,
    clickHandler,
    copyQuestion,
    changeQuestionPosition,
    skill,
    departments,
    isActionDisabled
  }) => {
  // const reviewRadios = new Array(
  //   skill
  //     ? question.skillType === "score5"
  //       ? 5
  //       : question.skillType === "score10"
  //       ? 10
  //       : 0
  //     : question.questionType === "score5"
  //     ? 5
  //     : question.questionType === "score10"
  //     ? 10
  //     : 0
  // ).fill(0);

  const reviewRadios = new Array(
    question.skillType === QUESTION_TYPE.SCORE_5 || question.questionType === QUESTION_TYPE.SCORE_5 ? 5 :
      question.skillType === QUESTION_TYPE.SCORE_10 || question.questionType === QUESTION_TYPE.SCORE_10 ? 10 :
        question.skillType === QUESTION_TYPE.SCORE_20 || question.questionType === QUESTION_TYPE.SCORE_20 ? 20
          : 0
  ).fill(0);

  const getDepartment = () => {
    if (departments.length > 0) {
      const selectedDepartment = departments.find((dpt) => dpt.id === question.departmentID);
      if (selectedDepartment) {
        return selectedDepartment.text;
      }
    }
    return null;
  }

  return (
    <div className="questions_wrapper">
      <div
        // onClick={(e) => {
        //   e.stopPropagation();
        //   clickHandler(index);
        // }}
      >
        <div style={{display: "flex", justifyContent: "space-between"}}>
          <div className="heading">
            {/* {question.name || question.question}
            {question.required && <span style={{ color: "red", margin: "0px" }}>*</span>} */}
            <FmlxLabel label={question.name || question.question} required={question.required}/>
          </div>
          <div onClick={(e) => e.stopPropagation()} style={{display: "flex", gap: "8px"}}>
            <FmlxCheckBox
              label="SELF"
              labelPlacement={FMLX_CHECK_BOX.LABEL_PLACEMENT.RIGHT}
              disabled={true}
              size={FMLX_CHECK_BOX.SIZE.M}
              checked={question.forSelf}
              onChange={() => {
              }}
            />
            <FmlxCheckBox
              label="PEER"
              labelPlacement={FMLX_CHECK_BOX.LABEL_PLACEMENT.RIGHT}
              disabled={true}
              size={FMLX_CHECK_BOX.SIZE.M}
              checked={question.forPeer}
              onChange={() => {
              }}
            />
            <FmlxCheckBox
              label="MANAGER"
              labelPlacement={FMLX_CHECK_BOX.LABEL_PLACEMENT.RIGHT}
              disabled={true}
              size={FMLX_CHECK_BOX.SIZE.M}
              checked={question.forManager}
              onChange={() => {
              }}
            />
            {/* <FmlxButton
              label="SELF"
              size={FMLX_COMPONENT.SIZE.L}
              type={FMLX_BUTTON.TYPE.POSITIVE}
              variant={question.forSelf ? FMLX_BUTTON.VARIANT.CONTAIN : FMLX_BUTTON.VARIANT.PLAIN}
              onClick={() => {}}
              withTooltip={false}
              disabled={true}
            ></FmlxButton>
            <FmlxButton
              label="PEER"
              size={FMLX_COMPONENT.SIZE.L}
              type={FMLX_BUTTON.TYPE.POSITIVE}
              variant={question.forPeer ? FMLX_BUTTON.VARIANT.CONTAIN : FMLX_BUTTON.VARIANT.PLAIN}
              onClick={() => {}}
              withTooltip={false}
              disabled={true}
            ></FmlxButton>
            <FmlxButton
              label="MANAGER"
              size={FMLX_COMPONENT.SIZE.L}
              type={FMLX_BUTTON.TYPE.POSITIVE}
              variant={question.forManager ? FMLX_BUTTON.VARIANT.CONTAIN : FMLX_BUTTON.VARIANT.PLAIN}
              onClick={() => {}}
              withTooltip={false}
              disabled={true}
            ></FmlxButton> */}
          </div>
        </div>
        <div style={{marginTop: "16px", whiteSpace: "pre-wrap"}}>{question.description}</div>
        {reviewRadios.length > 0 && (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              margin: "17px auto",
            }}
          >
            <div
              style={{
                display: "grid",
                justifyItems: "center",
                alignItems: "end",
                // paddingLeft: index !== 0 && '25px',
              }}
            >
              <div></div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  width: "100%",
                  gap: "24px",
                  padding: "0px",
                }}
              >
                <Rating
                  onClick={() => {
                  }}
                  initialValue={0} // not working in my local laptop
                  iconsCount={reviewRadios.length} // not working in my local laptop
                  stars={reviewRadios.length}
                  ratingValue={0}
                  // size={50}
                  readonly
                  className={"ratingDotPoin"}
                  customIcons={iconArray[reviewRadios.length]}
                  // fillIcon={
                  //   <svg height="24" width="24" fill="currentColor">
                  //     <circle cx="12" cy="12" r="10" />
                  //   </svg>
                  // } // not working in my local laptop
                  // emptyIcon={
                  //   <svg height="24" width="24" fill="currentColor">
                  //     <circle cx="12" cy="12" r="10" />
                  //   </svg>
                  // } // not working in my local laptop
                  transition
                  // showTooltip
                  // tooltipArray={tooltipArray[reviewRadios.length]}
                  fillColorArray={fillColorArray[reviewRadios.length]}
                >
                  <svg height="24" width="24" fill="currentColor">
                    <circle cx="12" cy="12" r="10"/>
                  </svg>
                </Rating>
              </div>
              {/* <div
                style={{
                  width: "100%",
                  display: "flex",
                  gap: "24px",
                  padding: "0px 24px",
                }}
              >
                {reviewRadios.map((v, i) => {
                  return (
                    <div
                      key={i}
                      className="number"
                      style={{ width: "24px", display: "flex", justifyContent: "center" }}
                    >
                      {i + 1}
                    </div>
                  );
                })}
              </div> */}
            </div>
            <div
              style={{
                display: "grid",
                justifyItems: "center",
                alignItems: "end",
                // paddingLeft: index !== 0 && "25px",
              }}
            >
              <div></div>
            </div>
          </div>
        )}
        <div>
          <div>
            {/* Please provide comment to explain your answer<span style={{ color: "red", margin: "0px" }}>*</span> */}
            <FmlxLabel label={"Please provide comment to explain your answer"} required={question.commentsRequired}/>
          </div>
          <div>
            <textarea
              style={{
                border: "1px solid #999999",
                borderRadius: "2px",
                height: "121px",
                width: "100%",
                padding: "8px 12px",
              }}
              type={"text"}
              placeholder="Type your comment here..."
            />
            {question.commentsRequired && question?.minimumofWords > 0 && (
              <FmlxLabel label={`Minimum ${question.minimumofWords} words`}/>
            )}
          </div>
        </div>

        <div className="action-button-div">
          <div className="question-wrapper--department-label">Department: {getDepartment()}</div>
          <div className="question-wrapper--action-button">
            <FmlxButton
              size={FMLX_COMPONENT.SIZE.XL}
              type={FMLX_BUTTON.TYPE.BASIC}
              variant={FMLX_BUTTON.VARIANT.PLAIN}
              disabled={isActionDisabled}
              label=""
              onClick={() => {
                copyQuestion(index);
              }}
              style={{cursor: "pointer"}}
              onlyIcon={true}
              icon={<FmlxIcon name={"ContentCopy"}/>}
              withTooltip={false}
              tooltipPlacement={"top"}
              tooltipDescription={"Copy Question"}
            ></FmlxButton>
            <FmlxButton
              size={FMLX_COMPONENT.SIZE.XL}
              type={FMLX_BUTTON.TYPE.PRIMARY}
              variant={FMLX_BUTTON.VARIANT.OUTLINE}
              disabled={isActionDisabled}
              label="Edit"
              onClick={() => {
                clickHandler(index);
              }}
              style={{cursor: "pointer"}}
              onlyIcon={true}
              // withIcon={FMLX_BUTTON.WITH_ICON.START}
              icon={<FmlxIcon name={"PencilBorder"}/>}
              withTooltip={false}
              tooltipPlacement={"top"}
              tooltipDescription={"Edit Question"}
            ></FmlxButton>
          </div>
        </div>
      </div>
      <QuestionPosition changeQuestionPosition={changeQuestionPosition} index={index}/>
    </div>
  );
};

export default Question;
